module.exports = __webpack_public_path__ + "static/media/2DGACM6.a1a16935.jpg";